/**
 * Age calculation utilities
 * 
 * Provides functions to calculate and display patient age,
 * with special handling for patients under 12 years (display in years and months).
 */

/**
 * Calculate age from date of birth
 * Returns age in years and months
 */
export function calculateAge(dateOfBirth: string): { years: number; months: number } {
  const birthDate = new Date(dateOfBirth)
  const today = new Date()
  
  let years = today.getFullYear() - birthDate.getFullYear()
  let months = today.getMonth() - birthDate.getMonth()
  
  if (months < 0) {
    years--
    months += 12
  }
  
  // Adjust if day hasn't occurred yet this month
  if (today.getDate() < birthDate.getDate()) {
    months--
    if (months < 0) {
      years--
      months += 12
    }
  }
  
  return { years, months }
}

/**
 * Get age display string
 * For patients under 12: "X years Y months"
 * For patients 12 and over: "X years"
 */
export function getAgeDisplay(dateOfBirth: string): string {
  const { years, months } = calculateAge(dateOfBirth)
  
  if (years < 12) {
    if (years === 0) {
      return `${months} ${months === 1 ? 'month' : 'months'}`
    }
    return `${years} ${years === 1 ? 'year' : 'years'} ${months} ${months === 1 ? 'month' : 'months'}`
  }
  
  return `${years} ${years === 1 ? 'year' : 'years'}`
}

/**
 * Check if patient is under 12 years old
 */
export function isUnder12(dateOfBirth: string): boolean {
  const { years } = calculateAge(dateOfBirth)
  return years < 12
}

